import React from 'react';
import './LabelValue.scss';

interface LabelValueProps {
    label: React.ReactNode;
    value: React.ReactNode;
}

const LabelValue: React.FC<LabelValueProps> = ({ label, value }) => {
    return (
        <div className="LabelValue flex justify-between items-center">
            <div className="LabelValue__label nereus-callout nereus-color-neutral-grey">{label}</div>
            <div className="LabelValue__value nereus-callout nereus-color-white pl-2">{value}</div>
        </div>
    );
};

export default LabelValue;
